import React from "react";

import { Col, Container, Row } from "react-bootstrap";

interface HeroComponentProps {
  title: string;
  description: string | React.ReactNode;
}

const BannerComponent: React.FC<HeroComponentProps> = ({
  title,
  description,
}) => (
  <Container className="text-center mt-5 mb-5 bannerContainer">
    <Row>
      <Col xs={{ span: 10, offset: 1 }}>
        <h1>{title}</h1>
        <p>{description}</p>
      </Col>
    </Row>
  </Container>
);

export default BannerComponent;
